import { cn } from 'utils/functions';

interface LoaderProps {
  color?: string;
  width?: string;
  height?: string;
  borderWidth?: string;
  className?: string;
}

const Loader = ({ color, width, height, borderWidth, className } : LoaderProps) => {
  return (
    <div
      className={cn(
        'border-t-4 border-transparent border-opacity-25 rounded-full animate-spin mx-auto',
        borderWidth ? borderWidth : 'border-2',
        color || 'border-t-primary',
        width || 'w-12',
        height || 'h-12',
        className
      )}
    ></div>
  );
};

export default Loader;
